import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";

export default class FeatureStopState extends BaseState {

  begin() {
    Signals.forceRoundEnd.add(this.onForceRoundEnd, this)

    const currentBonus = Facade.model.bonuses[Facade.model.currentBonusIndex]
    Signals.stopFeature.dispatch(currentBonus)
    Facade.model.currentBonusIndex++
  }

  onForceRoundEnd() {
    this.stateMachine.setState(GameStatesEnum.ROUND_END)
  }

  onSocketClosed() {
    this.stateMachine.setState(GameStatesEnum.RECONNECT_SOCKET)
  }

  cleanUp() {
    Signals.forceRoundEnd.remove(this.onForceRoundEnd, this)
   }
}
